// Indian-format currency + number helpers

export function inr(v) {
  if (v == null || isNaN(v)) return "—";
  const a = Math.abs(v);
  if (a >= 1e7) return `₹${(v / 1e7).toFixed(2)} Cr`;
  if (a >= 1e5) return `₹${(v / 1e5).toFixed(2)} L`;
  if (a >= 1e3) return `₹${(v / 1e3).toFixed(1)}k`;
  return `₹${v.toFixed(0)}`;
}

export function inrL(v, digits = 2) {
  if (v == null || isNaN(v)) return "—";
  return `₹${v.toFixed(digits)}`;
}

export function num(v, digits = 0) {
  if (v == null || isNaN(v)) return "—";
  return v.toLocaleString("en-IN", { maximumFractionDigits: digits, minimumFractionDigits: digits });
}

export const STATUS = {
  Normal: { color: "#10b981", bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-500", ring: "ring-emerald-500" },
  Watch: { color: "#0ea5e9", bg: "bg-sky-50", text: "text-sky-700", border: "border-sky-400", ring: "ring-sky-400" },
  Warning: { color: "#f59e0b", bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-500", ring: "ring-amber-500" },
  High: { color: "#f59e0b", bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-500", ring: "ring-amber-500" },
  Critical: { color: "#ef4444", bg: "bg-red-50", text: "text-red-700", border: "border-red-500", ring: "ring-red-500" },
  Low: { color: "#64748b", bg: "bg-slate-50", text: "text-slate-600", border: "border-slate-300", ring: "ring-slate-300" },
  Medium: { color: "#f59e0b", bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-500", ring: "ring-amber-500" },
};

export function statusOf(key) {
  return STATUS[key] || STATUS.Normal;
}

export function trendArrow(v) {
  if (v > 0) return { sym: "▲", cls: "text-red-500" };
  if (v < 0) return { sym: "▼", cls: "text-emerald-500" };
  return { sym: "=", cls: "text-slate-400" };
}
